import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c(VAppBar,{staticClass:"lindi darken-2",attrs:{"app":"","dark":""}},[_c(VToolbarTitle,{staticClass:"headline text-uppercase"},[_c('span',[_vm._v("PLP/")]),_c('span',{staticClass:"font-weight-light"},[_vm._v("PRODUCCIÓN")])]),_c(VSpacer)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }